import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './ScheduleOfFacilitiesComponent.module.scss';
import metadata from './ScheduleOfFacilitiesComponent.metadata.json5';

function ScheduleOfFacilitiesComponent(props) {

    const {
        data: ScheduleOfFacilitiesComponentVM,
        updateWizardData,
        submissionVM,
        ScheduleOfFacilitiesComponentPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    const addScheduleOfFacilities = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            ScheduleOfFacilitiesComponentVM.value = ScheduleOfFacilitiesComponentVM.value || []

            const { _xCenter, _dtoName } = ScheduleOfFacilitiesComponentVM;

            const SubsidiaryInformationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SubsidiaryInformationObjVM.value.annNumOfPro3 = 0
            SubsidiaryInformationObjVM.value.perOfRev2 = 0

            ScheduleOfFacilitiesComponentVM.pushElement(
                SubsidiaryInformationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, ScheduleOfFacilitiesComponentVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            ScheduleOfFacilitiesComponentVM.value.splice(index, 1);
            _.set(submissionVM.value, ScheduleOfFacilitiesComponentPath, ScheduleOfFacilitiesComponentVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ScheduleOfFacilitiesComponentPath, ScheduleOfFacilitiesComponentVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'facSer1') {
                const value = (item && item.facSer1) ? item.facSer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = ScheduleOfFacilitiesComponentVM.length > 0 && ScheduleOfFacilitiesComponentVM.children[index].facSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? ScheduleOfFacilitiesComponentVM.children[index].facSer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.facSer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'perOfRev2') {
                const value = item.perOfRev2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'annNumOfPro3') {
                const value = item.annNumOfPro3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.annNumOfPro3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des4' && !_.isUndefined(item.facSer1) && item.facSer1 === 'Other') {
                const value = item.des4 ? item.des4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange, translator, ScheduleOfFacilitiesComponentVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ScheduleOfFacilitiesTable`]: {
            data: ScheduleOfFacilitiesComponentVM.value,
        }

    }), [ScheduleOfFacilitiesComponentVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addScheduleOfFacilities,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            ScheduleOfFacilitiesComponentVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [ScheduleOfFacilitiesComponentVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={ScheduleOfFacilitiesComponentVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ScheduleOfFacilitiesComponent.propTypes = wizardProps;
export default withRouter(ScheduleOfFacilitiesComponent);
